import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
import { baseProductValidatorSharedMap } from "./SWBaseProduct";
/** @public */ export const resourceIdValidator = idValidator("product_detail");
/** @public */ export function createProductDetailValidator(type, props, meta) {
    return T.object({
        id: resourceIdValidator,
        typeName: T.literal("product_detail"),
        type: T.literal(type),
        props: props ? T.object(props) : T.jsonValue,
        meta: meta ? T.object(meta) : T.jsonValue,
        rawPrice: T.number,
        rawTrialPeriodPrice: T.number,
        trialPeriodDays: T.number,
        period: T.literalEnum("lifetime", "year", "6 month", "quarter", "2 month", "month", "week", "day"),
        ...baseProductValidatorSharedMap
    });
}
